import React from "react"

import { Button } from "../../../../../../shadcn/Button"
import STYLED_BUTTON_ID from "../../../constant/styledButtonId"

type Props = {
  onClick?: () => void
  buttonText: string
  children?: React.ReactNode
  isShowSaveEstimate?: boolean // 「見積を保存」ボタンの表示・非表示を決定するフラグ
  id?: string
}

const TotalResult = ({ onClick, buttonText, children, isShowSaveEstimate, id }: Props) => {
  const disabled = !onClick
  return (
    <div>
      <div className={!isShowSaveEstimate ? "rounded-lg bg-white" : ""}>
        {children && <div className="bg-white text-[13px]">{children}</div>}
        <Button
          disabled={disabled}
          onClick={onClick}
          id={id}
          className="mb-2 h-10 w-full rounded-full bg-[#16A34A] text-sm font-medium text-white hover:bg-[#16A34A]/90"
        >
          {buttonText}
        </Button>
        {isShowSaveEstimate && (
          <Button
            disabled={disabled}
            onClick={onClick}
            id={STYLED_BUTTON_ID.SAVE_ESTIMATE}
            variant="outline"
            className="mb-2.5 h-10 w-full rounded-full border-2 border-[#16A34A] bg-white text-sm font-bold text-[#16A34A] hover:bg-white/90"
          >
            見積りを保存
          </Button>
        )}
      </div>
    </div>
  )
}

export default TotalResult
